import { createTheme } from '@mantine/core';

// Maps the Tailwind palette onto Mantine's dark scheme, so Mantine popovers
// and calendars look like the rest of the app. Shade roles in dark mode:
// 0 text, 2 dimmed, 3 placeholder, 4 border, 5 hover, 6 popover, 7 body.
export const mantineTheme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  autoContrast: true,
  colors: {
    brand: ['#eef8ef', '#d8efdb', '#b9e2be', '#9bd6a2', '#7dcb86', '#6cc677', '#5EC269', '#4fa759', '#418c49', '#33713a'],
    dark: ['#c1c4c1', '#b0b3b1', '#979B9A', '#7d8281', '#4b5563', '#212936', '#131825', '#131825', '#0f1320', '#0a0d16'],
  },
});
